import { gql } from '@apollo/client';

export default gql`
  fragment brokerPublicFragment on BrokerPublic {
    code
    primary
    character
    logo
    promoBanner
  }
`;
